module.exports = __webpack_public_path__ + "img/linodelke.72ae9a55.svg";